import React from 'react';

import { Col, Row, Container } from 'react-bootstrap';
import kakao from '../assets/snsicons/kakao.svg';
import insta from '../assets/snsicons/insta.svg';
import twitter from '../assets/snsicons/twitter.svg';
import discord from '../assets/snsicons/discord.svg';
import naver from '../assets/snsicons/naver.svg';
import telegram from '../assets/snsicons/telegram.svg';
import medium from '../assets/snsicons/medium.svg';
import '../css/footer.css';
import FilterApplyButton from './FilterApplyButton';
import FooterMobile from './FooterMobile';
const Footer = ({ backgroundColor = '#111111' }) => {
	return (
		<>
			<div id='footer'>
				<Container
					style={{
						borderTop: '1px solid #c9c9c9',
						width: '100%',
						'--bs-gutter-x': '0',
					}}
					fluid
				>
					<div
						className='footer_container'
						style={{
							backgroundColor: `${backgroundColor}`,
							display: 'flex',
						}}
					>
						{/* <Col xs={2} >
                            <div className="adr_box">
                                <h3>GET ON THE LIST</h3>
                                <div style={{ display: 'flex' }}>
                                    <input placeholder="Email Address" />
                                    <div className="mailing_register">
                                        Register
                                    </div>
                                </div>
                            </div>
                        </Col> */}
						{/* <Col xs={12} > */}
						<div className='adr_box lg-12'>
							<div>
								<h3>Head</h3>
								<p>
									CDF Switzerland GmbH - Konnect
									<br />
									Banhhofstrasse 21, 6300 Zug,
									<br />
									Switzerland
									<br />
									contact@konnect.finance
									<br />
									<b>
										ⓒ Copyright 2022 KCT All rights are
										reserved.
									</b>
								</p>
							</div>
							<div>
								<h3>Korea Branch</h3>
								<p>
									씨디에프스위치랜드 유한책임회사(CDF
									Switzerland GmbH)
									<br />
									대표자 정용석
									<br />
									사업자등록번호 518-84-00025
								</p>
							</div>
						</div>
						<div className='sns_box'>
							<div className='sns_icon'>
								<a
									href='https://t.me/KonnectAnnouncements'
									target='_blank'
									rel='noreferrer'
								>
									<img src={telegram} />
								</a>
								<a
									href='https://twitter.com/KONNECT_KCT'
									target='_blank'
									rel='noreferrer'
								>
									<img src={twitter} />
								</a>
								<a
									href='https://www.instagram.com/konnectkct/'
									target='_blank'
									rel='noreferrer'
								>
									<img src={insta} />
								</a>
								<a
									href='https://medium.com/@KONNECT_KCT'
									target='_blank'
									rel='noreferrer'
								>
									<img src={medium} />
								</a>
								<a
									href='https://pf.kakao.com/_yQxcNb'
									target='_blank'
									rel='noreferrer'
								>
									<img src={kakao} />
								</a>
								<a
									href='https://blog.naver.com/konnect_finance'
									target='_blank'
									rel='noreferrer'
								>
									<img src={naver} />
								</a>
								<a
									href='https://discord.com/invite/konnect'
									target='_blank'
									rel='noreferrer'
								>
									<img src={discord} />
								</a>
							</div>
							<div className='sns_textbox'>
								<p>
									A space where virtual and reality
									connect&nbsp;&nbsp;&nbsp;|{' '}
								</p>
								<p>&copy;2022 Konnect</p>
							</div>
						</div>
						{/* </Col> */}
					</div>
				</Container>
			</div>
			<div id='footer_m'>
				<FooterMobile />
			</div>
		</>
	);
};

export default Footer;
